import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
    clearFilters: {
      id: 'course-authoring.search-manager.clearFilters',
      defaultMessage: 'Wyczyść filtry',
      description: 'Etykieta przycisku, który usuwa wszystkie zastosowane filtry wyszukiwania',
    },
    inputPlaceholder: {
      id: 'course-authoring.search-manager.inputPlaceholder',
      defaultMessage: 'Szukaj',
      description: 'Tekst zastępczy wyświetlany w polu wprowadzania słów kluczowych, gdy użytkownik nie wprowadził jeszcze słowa kluczowego',
    },
    clearUsageKeyToSearch: {
      id: 'course-authoring.search-manager.clearUsageKeyToSearch',
      defaultMessage: 'Wyświetlany pojedynczy blok, wyczyść filtry, aby wyszukać',
      description: 'Tekst zastępczy wyświetlany w polu wprowadzania słów kluczowych, gdy pokazany jest pojedynczy blok, przefiltrowany przez klucz użycia',
    },
    blockTypeFilter: {
      id: 'course-authoring.search-manager.blockTypeFilter',
      defaultMessage: 'Typ',
      description: 'Etykieta filtra, który umożliwia ograniczenie wyników do określonego typu komponentu',
    },
    'blockTypeFilter.empty': {
      id: 'course-authoring.search-manager.blockTypeFilter.empty',
      defaultMessage: 'Brak pasujących komponentów',
      description: 'Etykieta wyświetlana, gdy nie ma dostępnych opcji do filtrowania według typu komponentu',
    },
    childTagsExpand: {
      id: 'course-authoring.search-manager.child-tags-expand',
      defaultMessage: 'Rozwiń, aby wyświetlić tagi podrzędne dla "{tagName}"',
      description: 'Ten tekst opisuje przycisk przełączania rozwijania ▼ dla użytkowników niekorzystających ze wzroku.',
    },
    childTagsCollapse: {
      id: 'course-authoring.search-manager.child-tags-collapse',
      defaultMessage: 'Zwiń, aby ukryć tagi podrzędne dla "{tagName}"',
      description: 'Ten tekst opisuje przycisk przełączania zwijania ▲ dla użytkowników niekorzystających ze wzroku.',
    },
    'blockTagsFilter.empty': {
      id: 'course-authoring.search-manager.blockTagsFilter.empty',
      defaultMessage: 'Brak tagów w bieżących wynikach',
      description: 'Etykieta wyświetlana, gdy nie ma dostępnych opcji do filtrowania według tagów',
    },
    'blockTagsFilter.error': {
      id: 'course-authoring.search-manager.blockTagsFilter.error',
      defaultMessage: 'Błąd ładowania tagów',
      description: 'Etykieta wyświetlana, gdy tagi nie mogły zostać załadowane',
    },
    'blockTagsFilter.incomplete': {
      id: 'course-authoring.search-manager.blockTagsFilter.incomplete',
      defaultMessage: 'Przepraszamy, nie wszystkie tagi mogły zostać załadowane',
      description: 'Etykieta wyświetlana, gdy system nie jest w stanie wyświetlić wszystkich dostępnych opcji tagów.',
    },
    'blockType.annotatable': {
      id: 'course-authoring.course-search.blockType.annotatable',
      defaultMessage: 'Adnotacja',
      description: 'Nazwa typu komponentu "Adnotacja" w Studio',
    },
    'blockType.chapter': {
      id: 'course-authoring.course-search.blockType.chapter',
      defaultMessage: 'Sekcja',
      description: 'Nazwa poziomu zarysu kursu "Sekcja" w Studio',
    },
    'blockType.collection': {
      id: 'course-authoring.course-search.blockType.collection',
      defaultMessage: 'Kolekcja',
      description: 'Tekst typu kolekcji',
    },
    'blockType.collection.with_count': {
      id: 'course-authoring.course-search.blockType.collectionWithCount',
      defaultMessage: 'Kolekcja ({count})',
      description: 'Tekst typu kolekcji z liczbą elementów podrzędnych',
    },
    'blockType.discussion': {
      id: 'course-authoring.course-search.blockType.discussion',
      defaultMessage: 'Dyskusja',
      description: 'Nazwa typu komponentu "Dyskusja" w Studio',
    },
    'blockType.drag-and-drop-v2': {
      id: 'course-authoring.course-search.blockType.drag-and-drop-v2',
      defaultMessage: 'Przeciągnij i Upuść',
      description: 'Nazwa typu komponentu "Przeciągnij i Upuść" w Studio',
    },
    'blockType.html': {
      id: 'course-authoring.course-search.blockType.html',
      defaultMessage: 'Tekst',
      description: 'Nazwa typu komponentu "Tekst" w Studio',
    },
    'blockType.library_content': {
      id: 'course-authoring.course-search.blockType.library_content',
      defaultMessage: 'Zawartość Biblioteki',
      description: 'Nazwa typu komponentu "Zawartość Biblioteki" w Studio',
    },
    'blockType.openassessment': {
      id: 'course-authoring.course-search.blockType.openassessment',
      defaultMessage: 'Ocena Otwartej Odpowiedzi',
      description: 'Nazwa typu komponentu "Ocena Otwartej Odpowiedzi" w Studio',
    },
    'blockType.problem': {
      id: 'course-authoring.course-search.blockType.problem',
      defaultMessage: 'Problem',
      description: 'Nazwa typu komponentu "Problem" w Studio',
    },
    'blockType.sequential': {
      id: 'course-authoring.course-search.blockType.sequential',
      defaultMessage: 'Podsekcja',
      description: 'Nazwa poziomu zarysu kursu "Podsekcja" w Studio',
    },
    'blockType.vertical': {
      id: 'course-authoring.course-search.blockType.vertical',
      defaultMessage: 'Jednostka',
      description: 'Nazwa poziomu zarysu kursu "Jednostka" w Studio',
    },
    'blockType.video': {
      id: 'course-authoring.course-search.blockType.video',
      defaultMessage: 'Wideo',
      description: 'Nazwa typu komponentu "Video" w Studio',
    },
    'blockType.choiceresponse': {
      id: 'course-authoring.course-search.blockType.choiceresponse',
      defaultMessage: 'Wielokrotny Wybór',
      description: 'Nazwa typu komponentu "choiceresponse" w Studio',
    },
    'blockType.multiplechoiceresponse': {
      id: 'course-authoring.course-search.blockType.multiplechoiceresponse',
      defaultMessage: 'Pola Wyboru',
      description: 'Nazwa typu komponentu "multiplechoiceresponse" w Studio',
    },
    'blockType.numericalresponse': {
      id: 'course-authoring.course-search.blockType.numericalresponse',
      defaultMessage: 'Wprowadzanie Liczb',
      description: 'Nazwa typu komponentu "numericalresponse" w Studio',
    },
    'blockType.optionresponse': {
      id: 'course-authoring.course-search.blockType.optionresponse',
      defaultMessage: 'Lista Rozwijana',
      description: 'Nazwa typu komponentu "optionresponse" w Studio',
    },
    'blockType.stringresponse': {
      id: 'course-authoring.course-search.blockType.stringresponse',
      defaultMessage: 'Wprowadzanie Tekstu',
      description: 'Nazwa typu komponentu "stringresponse" w Studio',
    },
    'blockType.formularesponse': {
      id: 'course-authoring.course-search.blockType.formularesponse',
      defaultMessage: 'Wyrażenie Matematyczne',
      description: 'Nazwa typu komponentu "formularesponse" w Studio',
    },
    blockTagsFilter: {
      id: 'course-authoring.search-manager.blockTagsFilter',
      defaultMessage: 'Tagi',
      description: 'Etykieta filtra, który umożliwia znajdowanie komponentów z określonymi tagami',
    },
    searchTagsByKeywordPlaceholder: {
      id: 'course-authoring.search-manager.searchTagsByKeywordPlaceholder',
      defaultMessage: 'Wyszukaj tagi',
      description: 'Tekst zastępczy wyświetlany w polu wprowadzania, które umożliwia przeszukiwanie dostępnych tagów',
    },
    submitSearchTagsByKeyword: {
      id: 'course-authoring.search-manager.submitSearchTagsByKeyword',
      defaultMessage: 'Prześlij wyszukiwanie tagów według słowa kluczowego',
      description: 'Tekst wyświetlany użytkownikom czytników ekranu dla przycisku wyszukiwania w wyszukiwaniu tagów według słowa kluczowego',
    },
    numResults: {
      id: 'course-authoring.course-search.num-results',
      defaultMessage: '{numResults, plural, one {# wynik} few {# wyniki} other {# wyników}} znaleziono',
      description: 'Ta liczba wyświetla, ile pasujących wyników zostało znalezionych w wyszukiwaniu użytkownika',
    },
    clearFilter: {
      id: 'course-authoring.search-manager.searchFilterWidget.clearFilter',
      defaultMessage: 'Wyczyść Filtr',
      description: 'Etykieta dla przycisku, który usuwa zastosowane filtry wyszukiwania w określonym widżecie',
    },
    searchSortWidgetLabel: {
      id: 'course-authoring.course-search.searchSortWidget.label',
      defaultMessage: 'Sortuj Według',
      description: 'Etykieta wyświetlana użytkownikom, gdy domyślne sortowanie jest używane przez rozwijane menu wyszukiwania treści',
    },
    searchSortWidgetAltTitle: {
      id: 'course-authoring.course-search.searchSortWidget.title',
      defaultMessage: 'Sortuj wyniki wyszukiwania',
      description: 'Tekst alternatywny/tytułu dla rozwijanego menu sortowania wyszukiwania treści',
    },
    searchSortTitleAZ: {
      id: 'course-authoring.course-search.searchSort.titleAZ',
      defaultMessage: 'Tytuł, A-Z',
      description: 'Etykieta dla rozwijanego sortowania wyszukiwania treści, które sortuje według tytułu treści, rosnąco',
    },
    searchSortTitleZA: {
      id: 'course-authoring.course-search.searchSort.titleZA',
      defaultMessage: 'Tytuł, Z-A',
      description: 'Etykieta dla rozwijanego sortowania wyszukiwania treści, które sortuje według tytułu treści, malejąco',
    },
    searchSortNewest: {
      id: 'course-authoring.course-search.searchSort.newest',
      defaultMessage: 'Najnowsze',
      description: 'Etykieta dla rozwijanego sortowania wyszukiwania treści, które sortuje według daty utworzenia, malejąco',
    },
    searchSortOldest: {
      id: 'course-authoring.course-search.searchSort.oldest',
      defaultMessage: 'Najstarsze',
      description: 'Etykieta dla rozwijanego sortowania wyszukiwania treści, które sortuje według daty utworzenia, rosnąco',
    },
    searchSortRecentlyPublished: {
      id: 'course-authoring.course-search.searchSort.recentlyPublished',
      defaultMessage: 'Ostatnio Opublikowane',
      description: 'Etykieta dla rozwijanego sortowania wyszukiwania treści, które sortuje według daty publikacji, malejąco',
    },
    searchSortRecentlyModified: {
      id: 'course-authoring.course-search.searchSort.recentlyModified',
      defaultMessage: 'Ostatnio Zmodyfikowane',
      description: 'Etykieta dla rozwijanego sortowania wyszukiwania treści, które sortuje według daty modyfikacji, malejąco',
    },
    openProblemSubmenuAlt: {
      id: 'course-authoring.filter.problem-submenu.icon-button.alt',
      defaultMessage: 'Otwórz filtry typów problemów',
      description: 'Tekst alternatywny dla przycisku ikony otwierającego filtry typów problemów',
    },
    searchSortMostRelevant: {
      id: 'course-authoring.course-search.searchSort.mostRelevant',
      defaultMessage: 'Najbardziej Trafne',
      description: 'Etykieta dla rozwijanego sortowania wyszukiwania treści, które sortuje wyszukiwania słów kluczowych według trafności',
    },
});

export default messages;
